import { useEffect, useState } from 'react';

import { axios } from '../api';
import { Lead } from '../pages/types';

export const useGetLead = (leadId: string) => {
  const [lead, setLead] = useState<Lead | null>(null);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios
      .post<Lead[]>('lead_search', { funnel_session_id: leadId })
      .then(({ data }) => {
        if (!data[0]) {
          setIsError(true);
        } else {
          setLead(data[0]);
        }
      })
      .catch(() => setIsError(true))
      .finally(() => setIsLoading(false));
  }, [leadId]);

  return { lead, isLoading, isError };
};
